module.exports = __webpack_public_path__ + "img/telefono.02383d93.svg";